export const normalizeSrgbColorToHex = colorStr => {
  if (!colorStr) {
    return colorStr;
  }

  // Convert CSS Color Level 4 "color(srgb R G B)" to hex (unsupported by 'color' package)
  const srgbMatch = colorStr.match(/color\(srgb\s+([\d.]+)\s+([\d.]+)\s+([\d.]+)(?:\s*\/\s*([\d.]+))?\)/i);
  if (srgbMatch) {
    const [, r, g, b, a] = srgbMatch;
    const to255 = val => Math.round(parseFloat(val) * 255);
    const rNum = to255(r);
    const gNum = to255(g);
    const bNum = to255(b);
    if (a !== undefined) {
      return `rgba(${rNum}, ${gNum}, ${bNum}, ${parseFloat(a)})`;
    }
    const toHex = val => val.toString(16).padStart(2, '0').toUpperCase();
    return `#${toHex(rNum)}${toHex(gNum)}${toHex(bNum)}`;
  }
  return colorStr;
};
//# sourceMappingURL=normalize-css-color.js.map